import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { session, isLoading } = useAuth();
  const location = useLocation();

  console.log('[ProtectedRoute] Checking access:', {
    timestamp: new Date().toISOString(),
    path: location.pathname,
    isLoading,
    hasSession: !!session,
    userId: session?.user?.id,
    email: session?.user?.email,
  });

  if (isLoading) {
    console.log('[ProtectedRoute] Still loading, showing spinner');
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!session) {
    console.log('[ProtectedRoute] No session, redirecting to /auth');
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  console.log('[ProtectedRoute] Session valid, rendering children');
  return <>{children}</>;
};

export default ProtectedRoute;
